import BaseFormView from "./baseFormView";
import CurationCollection from "scripts/collections/curationCollection";
import CurationMediaModel from "scripts/models/curationMediaModel";
import templateCurationAddMediaForm from "templates/curationAddMediaForm.hbs";

const formatCurationOption = curationMap => option => {
  const curation = curationMap[option.id];

  if (curation) {
    return $(
      `<div class="bb-curation-autocomplete-option">
        <div class="bb-curation-autocomplete-icon" style="background-image: url('${
          curation.thumbnailUrl
        }')"></div>
        <div class="bb-curation-autocomplete-text">${curation.title}</div>
      </div>`,
    );
  } else {
    return $(`<span>${option.text}</span>`);
  }
};

class CurationAddMediaFormView extends BaseFormView {
  get template() {
    return templateCurationAddMediaForm;
  }

  get events() {
    return {
      "change form *[name]": "onInputEnableSubmit",
      "submit form": "onSubmit",
      "click #bb-curation-add-media-form-new-curation": "onClickCreateCuration",
    };
  }

  constructor(options) {
    super(options);

    this.curationCollection = new CurationCollection([], {
      comparator: "title",
      queryStringParams: {
        unpublished: true,
        sort: "title",
      },
    });

    this.bindModel(
      new CurationMediaModel({
        id: this.model.get("id"),
      }),
    );
  }

  render() {
    const curations = this.curationCollection.toJSON();

    this.$el.html(
      this.template({
        curations,
      }),
    );

    const curationMap = {};
    curations.forEach(curation => {
      curationMap[curation.id] = curation;
    });

    this.loaderView
      .appendTo(this.$el.find(".bb-form-submit-button-loader-region"))
      .render();

    this.$el.find("#bb-curation-add-media-form-curation-select").select2({
      dropdownParent: $("#bb-app-modal"),
      placeholder: "Select a curation",
      templateResult: formatCurationOption(curationMap),
    });

    this.enableSubmit(this.isValid());

    return this;
  }

  sync() {
    return this.curationCollection.fetch();
  }

  onSubmitFailed(error) {
    this.enableSubmit(true);

    this.trigger("failure", error);
  }

  onSubmitSucceeded() {
    this.enableSubmit(false);
    this.trigger("success", this.model.get("curation"));
  }

  save() {
    this.clearErrors();

    return this.model.save(this.toJSON(), {
      type: "POST",
    });
  }

  onClickCreateCuration() {
    this.trigger("createCuration");
  }
}

export default CurationAddMediaFormView;
